import ObjectModelPermission from "./objectModelPermission";

export default class ObjectModelActionPermission extends ObjectModelPermission {
  get action_client_id(): string {
    return this.permittable_client_id;
  }
}